import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';

import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMobileLayout from 'Hooks/useMobileLayout';
import { Offer } from './offer';
import { offerMetaOverrideSet } from './metaOverrideSet';

export const Offers = ({
  options,
  onChoose,
}) => {
  const isMobile = useMobileLayout();
  return (
    <>
      <FDStack spacing={2} direction={isMobile ? 'column' : 'row'} alignItems="flex-start">
        {options.map(option => (
          <MetaResourceRenderer
            resource={option}
            layout={Offer}
            LayoutProps={{ onChoose }}
            metaOverrideSet={offerMetaOverrideSet}
          />
        ))}
      </FDStack>
    </>
  );
};

Offers.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChoose: PropTypes.func.isRequired,
};
